module.exports = __webpack_public_path__ + "assets/chat-bg-2.6bb72258.svg";